import gsap from 'gsap'

class Navigation {
  constructor() {
    this.Navigation()
  }

  Navigation() {
    this.condensed = false
    this.mobileOpen = false

    window.addEventListener('load', () => {
      this.scrolled()
      this.resized()
    })

    document
      .querySelector('.navigation__toggle')
      .addEventListener('click', () => {
        if (this.mobileOpen) {
          this.closeMobileNav()
        } else {
          this.openMobileNav()
        }
      })

    window.addEventListener('scroll', () => {
      this.scrolled()
    })
    window.addEventListener('resize', () => {
      this.resized()
    })
  }

  scrolled() {
    this.adjustNavType()
  }

  resized() {
    this.adjustNavType()
  }

  adjustNavType() {
    if (window.pageYOffset > 150 && !this.condensed) {
      this.condenseNav()
    } else if (window.pageYOffset < 150 && this.condensed) {
      this.expandNav()
    }

    if (window.innerWidth >= 763 && this.mobileOpen) {
      this.closeMobileNav()
    }
  }

  condenseNav() {
    this.condensed = true
    document.querySelector('.navigation').classList.add('navigation--scrolled')
    document
      .querySelector('.navigationMobile')
      .classList.add('navigationMobile--scrolled')
  }

  expandNav() {
    this.condensed = false
    document
      .querySelector('.navigation')
      .classList.remove('navigation--scrolled')
    document
      .querySelector('.navigationMobile')
      .classList.remove('navigationMobile--scrolled')
  }

  openMobileNav() {
    this.mobileOpen = true

    const elMobile = document.querySelector('.navigationMobile')
    gsap.to(elMobile, {
      alpha: 1,
      duration: 0.35,
    })
    elMobile.style.display = 'block'

    document.querySelector('.navigation').classList.add('mobileOpen')
    document.body.classList.add('no-scroll')
    document.querySelector('.navigation__toggle').classList.add('is-active')
  }

  closeMobileNav() {
    this.mobileOpen = false

    const elMobile = document.querySelector('.navigationMobile')
    gsap.to(elMobile, {
      alpha: 0,
      duration: 0.35,
      onComplete: () => {
        elMobile.style.display = 'none'
      },
    })

    document.querySelector('.navigation').classList.remove('mobileOpen')
    document.body.classList.remove('no-scroll')
    document.querySelector('.navigation__toggle').classList.remove('is-active')
  }
}

export default Navigation
